// extracted by mini-css-extract-plugin
export default {"nav":"Menu_nav__fC3L9","icon":"Menu_icon__3L7yo","openMenu":"Menu_openMenu__Swt-4","open":"Menu_open__Yx1ou","menuItem":"Menu_menuItem__6-OK0"};